import React from 'react';
import {Badge} from 'react-bootstrap'
import {prezTime} from '../../util/prez'
import {getCompetitorRowClassName} from '../../util/competitorUtil'


export default (props) => {
const typeOfResult = props.event.resultConfig.resultList
console.log(props.event.resultConfig.resultList)
    return (
        <tr className={ getCompetitorRowClassName( props.competitor)}>
        <td>
            {props.competitor.rankNo ? 
            props.competitor.rankNo : <Badge variant="danger">{props.competitor.status}</Badge>}
        </td>
        <td className="d-sm-none">{props.competitor.person ? props.competitor.person.firstName + " " + props.competitor.person.lastName : '' } <span className="clubName">{props.competitor.club ? props.competitor.club.name : null}</span></td>
        <td className="d-none d-sm-table-cell">{props.competitor.person ? props.competitor.person.firstName : null}</td>
        <td className="d-none d-sm-table-cell">{props.competitor.person ? props.competitor.person.lastName : null}</td>
        <td className="d-none d-sm-table-cell">{props.competitor.club ? props.competitor.club.name : null}</td>
        {typeOfResult === "ABSOLUTERANK" ? 
        <td>{prezTime( props.competitor.finishTime) }</td>
        : 
        <td style={{textAlign: "right"}}>{prezTime( props.competitor.raceTime) }</td>
    }
        <td className="d-none d-sm-table-cell" style={{fontSize: 'small', textAlign: "right"}}>{prezTime( props.competitor.timeToLeader)}</td>
    </tr>

)
}
